import { define, type, auto, Record } from 'type-r'
import BaseRecord from './base'

@define 
export default class ContactModel extends BaseRecord {
    @auto("") name: string
    @auto("") email: string
    @auto("") subject: string
    @auto("") phone: string
    @auto("") message: string
    @auto("") form_botcheck: string
    @auto("") recaptcha: string
    @auto(false) busy: boolean
}
